<template>
    <bscroll-view>
        <div id="seniorSearchResult">
            <div class="topSelect_warp">
                <div class="seleWarp">
                    <ul>
                        <li
                            v-for="(item, index) in setSelectList"
                            :key="index"
                            :class="[selectIndex == index ? 'active' : '']"
                            @click="setSelectClick(item.resource_type,index)"
                        >
                            {{ langTransfer(item.title) }}
                        </li>
                    </ul>
                </div>
                <!-- :style="{
                                background:
                                    selectIndex == index
                                        ? pageSetup.axuColor
                                        : 'rgba(247,247,247,1)',
                                color: selectIndex == index ? '#ffffff' : '#42476C',
                            }" -->
                <div class="minWarp">
                    <ul>
                        <li
                            v-for="(item, index) in setSelectList[selectIndex].children"
                            :key="index"
                        >
                            <!-- :style="{background:(index == 0 ? 'red' : 'green')}" -->
                            <div class="minWarp-left-wap">
                                <el-select
                                    v-model="item.state"
                                    :placeholder="langTransfer('标题/作者/正文/栏目..')"
                                >
                                    <el-option
                                        v-for="(itemNeed, indexneed) in fromval.state"
                                        v-show="
                                            selectIndex != 0 && itemNeed.title == '栏目'
                                                ? false
                                                : true
                                        "
                                        :key="indexneed"
                                        :label="langTransfer(itemNeed.title)"
                                        :value="itemNeed.val"
                                    />
                                </el-select>
                            </div>
                            <div class="minWarp-center-wap">
                                <el-select
                                    v-if="index != 0"
                                    v-model="item.type"
                                    :placeholder="langTransfer('包含-不含')"
                                >
                                    <el-option
                                        v-for="(itemNeed, indexneed) in fromval.type"
                                        :key="indexneed"
                                        :label="langTransfer(itemNeed.title)"
                                        :value="itemNeed.val"
                                    />
                                </el-select>
                                <!-- <el-select
                                    v-if="index != 0"
                                    v-model="item.state"
                                    :placeholder="langTransfer('标题/作者/正文/栏目..')"
                                    style="width: 100px"
                                >
                                    <el-option
                                        v-for="(itemNeed, indexneed) in fromval.state"
                                        v-show="
                                            selectIndex != 0 && itemNeed.title == '栏目' ? false : true
                                        "
                                        :key="indexneed"
                                        :label="langTransfer(itemNeed.title)"
                                        :value="itemNeed.val"
                                    />
                                </el-select> -->
                                <input
                                    v-model="item.content"
                                    type="text"
                                    class="mainInputval"
                                >
                            </div>

                            <div class="minWarp-right-wap">
                                <el-checkbox v-model="item.searchType">
                                    精确
                                </el-checkbox>
                            </div>
                            <!-- <el-select
                                    v-model="item.searchType"
                                    :placeholder="langTransfer('精选/模糊')"
                                    style="width: 104px"
                                >
                                    <el-option
                                        v-for="(itemNeed, indexneed) in fromval.searchType"
                                        :key="indexneed"
                                        :label="langTransfer(itemNeed.title)"
                                        :value="itemNeed.val"
                                    />
                                </el-select> -->
                        </li>
                    </ul>
                    <div class="minFooter">
                        <div class="clear-btn" @click="emptySelectData">
                            <img src="@/assets/clear-btn.png" alt="">
                            清空
                        </div>
                        <div class="search-btn" @click="retrievalClick">
                            检索
                        </div>
                        <!-- <button
                            :style="{ background: pageSetup.theme }"
                            @click="emptySelectData"
                        >
                            {{ langTransfer("清空") }}
                        </button>
                        <button
                            :style="{ background: pageSetup.axuColor }"
                            @click="retrievalClick"
                        >
                            {{ langTransfer("检索") }}
                        </button> -->
                    </div>
                </div>
            </div>
            <div class="senmainWarp">
                <div v-if="contList[0]" class="contNum">
                    <!-- <div v-if="setSelectList[0].children[0].content" class="senmainWarp-title">
                        为您找到“{{ setSelectList[0].children[0].content }}”相关结果
                    </div> -->
                    <!-- :style="{ color: pageSetup.axuColor }" -->
                    <div class="senmainWarp-setting">
                        <span>{{ langTransfer("共搜到") }}{{ contpage.contNum
                        }}{{ langTransfer("篇文章") }}</span>
                        <!-- <span :style="{ color: pageSetup.axuColor }">{{ langTransfer("共搜到") }}{{ contpage.contNum
                    }}{{ langTransfer("篇文章") }}</span> -->
                        <div class="c_degreeTimeWarp">
                            <span>排序方式：</span>
                            <button
                                :class="{ 'btn-active': cDegreeTimeWarp === 1 }"
                                @click="cDegreeTimeWarp_fn(1)"
                            >
                                {{ langTransfer("相关度") }}
                            </button>
                            <button
                                :class="{ 'btn-active': cDegreeTimeWarp === 2 }"
                                @click="cDegreeTimeWarp_fn(2)"
                            >
                                {{ langTransfer("时间") }}
                            </button>
                        </div>
                        <!-- <button
                            :style="{
                                background:
                                    cDegreeTimeWarp === 1 ? pageSetup.theme : pageSetup.axuColor,
                            }"
                            @click="cDegreeTimeWarp_fn(1)"
                        >
                            {{ langTransfer("相关度") }}
                        </button>
                        <button
                            :style="{
                                background:
                                    cDegreeTimeWarp === 2 ? pageSetup.theme : pageSetup.axuColor,
                            }"
                            @click="cDegreeTimeWarp_fn(2)"
                        >
                            {{ langTransfer("时间") }}
                        </button> -->
                    </div>
                </div>
                <div class="listWarp">
                    <seniorSearchList :contList="contList" :resource-type="resource_type" />
                </div>
                <emptyContent
                    v-if="contList[0] ? false : true"
                    con-text="请输入检索条件进行检索"
                />
                <div v-if="contList[0]" class="footerPage">
                    <!-- <div class="pagenumdata">
                        {{ langTransfer("每页显示") }}{{ contpage.pageSize
                        }}{{ langTransfer("条") }}
                    </div> -->
                    <div>
                        <pagination
                            :current-page="contpage.page"
                            :rows="contpage.pageSize"
                            :total="contpage.contNum"
                            @handleCurrentChangeSub="noChangePagination"
                        />
                    </div>
                    <!-- <div class="pagenumdata" /> -->
                </div>
                <div v-show="loadingIsShow" class="loadingWarp">
                    <img src="@/assets/loading.gif" alt="">
                </div>
            </div>
        </div>
        <footer-com />
    </bscroll-view>
</template>

<script>
    import BscrollView from '@/components/bscrollView'
    import seniorSearchList from '@/components/common/seniorSearchList/seniorSearchList.vue' // 文章列表
    import emptyContent from '@/components/emptyContent/emptyContent.vue' //无内容
    import { seniorSearchArticle } from '@/api/lxc'
    import pagination from '@/components/common/pagination/index.vue'
    import FooterCom from '@/components/footerCom/footerCom'

    export default {
        name: 'SeniorSearchResult',
        components: {
            BscrollView,
            seniorSearchList,
            emptyContent,
            pagination,
            FooterCom
        },
        data () {
            return {
                resource_type:1,
                loadingIsShow: false,
                cDegreeTimeWarp: 1,
                contpage: {
                    page: 1,
                    pageSize: 4,
                    contNum: 0
                },
                selectIndex: 0,
                fromval: {
                    type: [
                        { title: '包含', val: 1 },
                        { title: '不含', val: 2 }
                    ],
                    state: [
                        { title: '标题', val: 1 },
                        { title: '栏目', val: 2 },
                        { title: '作者', val: 3 },
                        { title: '正文', val: 4 }
                    ],
                    searchType: 2
                },
                setSelectList: [
                    {
                        title: '期刊',
                        resource_type:1,
                        children: [
                            {
                                type: 1,
                                state: 1,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 2,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 3,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 4,
                                content: '',
                                searchType: false
                            }
                        ]
                    },
                    {
                        title: '知识库',
                        resource_type:3,
                        children: [
                            {
                                type: 1,
                                state: 1,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 3,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 4,
                                content: '',
                                searchType: false
                            }
                        ]
                    }
                ],
                contList: []
            }
        },
        computed: {
            pageSetup () {
                return this.$store.state.pageSetup
            },
            webInfo () {
                return this.$store.state.webInfo
            }
        },
        created () {},
        mounted () {
            const { service_code } = this.webInfo
            if (service_code) {
            }
            this.$sta.staAdmin({
                oprate_type: '浏览',
                module_name: '高级搜索'
            })
        },
        methods: {
            emptySelectData () {
                this.setSelectList = [
                    {
                        title: '期刊',
                        resource_type:1,
                        children: [
                            {
                                type: 1,
                                state: 1,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 2,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 3,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 4,
                                content: '',
                                searchType: false
                            }
                        ]
                    },
                    {
                        title: '知识库',
                        resource_type:3,
                        children: [
                            {
                                type: 1,
                                state: 1,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 3,
                                content: '',
                                searchType: false
                            },
                            {
                                type: 1,
                                state: 4,
                                content: '',
                                searchType: false
                            }
                        ]
                    }
                ]
            },
            cDegreeTimeWarp_fn (index) {
                if (index === this.cDegreeTimeWarp) {
                    return false
                }
                this.cDegreeTimeWarp = index
                this.retrievalClick()
            },
            retrievalClick () {
                const comprehensive = {
                    title: [],
                    column: [],
                    author: [],
                    content: []
                }
                this.setSelectList[this.selectIndex].children.filter(
                    (item) => {
                        if (item.content != '' && item.content != null) {
                            if (item.state == 1) {
                                comprehensive.title.push(item)
                            } else if (item.state == 2) {
                                comprehensive.column.push(item)
                            } else if (item.state == 3) {
                                comprehensive.author.push(item)
                            } else if (item.state == 4) {
                                comprehensive.content.push(item)
                            }
                            return item
                        }
                    }
                )
                comprehensive.title.map((item,index)=>{
                    item.searchType = item.searchType == true ? 2 : 1
                })
                comprehensive.author.map((item,index)=>{
                    item.searchType = item.searchType == true ? 2 : 1
                })
                comprehensive.column.map((item,index)=>{
                    item.searchType = item.searchType == true ? 2 : 1
                })
                comprehensive.content.map((item,index)=>{
                    item.searchType = item.searchType == true ? 2 : 1
                })

                this.seniorSearchArticle_fn(comprehensive)

                comprehensive.title.map((item,index)=>{
                    item.searchType = item.searchType == 1 ? false : true
                })
                comprehensive.author.map((item,index)=>{
                    item.searchType = item.searchType == 1 ? false : true
                })
                comprehensive.column.map((item,index)=>{
                    item.searchType = item.searchType == 1 ? false : true
                })
                comprehensive.content.map((item,index)=>{
                    item.searchType = item.searchType == 1 ? false : true
                })
                
            },
            noChangePagination (res) {
                this.contpage.page = res
                this.retrievalClick()
            },
            async seniorSearchArticle_fn (val) {
                console.log(val)
                this.loadingIsShow = true
                try {
                    const data = await seniorSearchArticle({
                        service_code: this.webInfo.service_code,
                        content_json: JSON.stringify(val.content),
                        rAuthors_json: JSON.stringify(val.author),
                        rCates_json: JSON.stringify(val.column),
                        rTitles_json: JSON.stringify(val.title),
                        resource_type: this.resource_type,
                        order_type: this.cDegreeTimeWarp,
                        page: this.contpage.page,
                        pageSize: this.contpage.pageSize
                    })
                    this.loadingIsShow = false
                    this.contList = data.records
                    this.contpage.contNum = data.total
                    this.$sta.staAdmin({
                        oprate_type: '搜索',
                        module_name: '高级搜索',
                        resource_type: '综合',
                        search_content: this.$route.query.searchKey
                    })
                } catch (err) {
                    this.contList = []
                    this.loadingIsShow = false
                }
            },
            setSelectClick (item,index) {
                this.contList = []
                this.resource_type = item
                this.selectIndex = index
            }
        }
    }
</script>
<style lang="less">
#seniorSearchResult {
  .el-icon-arrow-up:before {
    content: "\e790" !important;
  }
  .el-checkbox__input {
    margin: 5px;
  }
  .el-checkbox__label {
    padding: 0;
  }
  .el-select {
    width: 80px;
    flex-shrink: 0;
  }
  .el-input {
    input {
      border: none !important;
      text-align: center;
      padding: 0;
      box-sizing: border-box;
      background: none;
    }
  }
}
</style>
<style scoped lang="less">
.senmainWarp {
  position: relative;
  width: 720px;
  margin-top: 35px;
  .senmainWarp-title {
    font-size: 13px;
    font-family: AlibabaPuHuiTiM;
    color: #909399;
    line-height: 24px;
    margin-bottom: 25px;
  }
  .loadingWarp {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
    display: flex;
    // align-items: center;
    justify-content: center;
    img {
      width: 150px;
      height: 150px;
    }
  }
}
#seniorSearchResult {
  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  justify-content: space-between;
  .footerPage {
    padding: 20px 0;
    display: flex;
    justify-content: center;
    .pagenumdata {
      width: 100px;
      height: 100%;
    }
  }
  width: 1200px;
  margin: auto;
  .contNum {
     .senmainWarp-setting{
        display: flex;
        justify-content: space-between;
        align-items: center;
    span {
      height: 18px;
      font-size: 18px;
      color: #303133;
      line-height: 24px;
    //   font-weight: 600;
    }

    .c_degreeTimeWarp {
      span {
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        line-height: 24px;
      }
      button {
        width: 50px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        color: #303133;
        background: #f0f2f5;
      }
      .btn-active {
        color: #ffffff;
        background: #303133;
      }
    }
    }

  }
  .listWarp {
    width: 100%;
    margin-left: -20px;
  }
}
.topSelect_warp {
  width: 432px;
  margin: 30px 0 0 0;
  border-radius: 6px;
  .minWarp {
    background: #fff;
    border-radius: 8px;
    justify-content: center;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding-bottom: 30px;
    .minWarp-left-wap {
      // width: 85px;
    }
    .minWarp-center-wap {
      width: 235px;
      display: flex;
      border-radius: 6px;
      align-items: center;
      // justify-content: space-between;
      border: 1px solid #cccccc;
      background: #fff;
      overflow: hidden;
    }
    .minWarp-right-wap {
      width: 44px;
      margin-left: 10px;
    }
    ul {
      width: 100%;
      padding: 0 0 30px 0;
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
      }
      li:first-child {
        background: #f5f7fa;
      }
    }
    .mainInputval {
      width: 100%;
      height: 38px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      outline: none;
      text-indent: 1em;
      border: none;
      flex-shrink: 0;
    }
  }
  .seleWarp {
    padding-bottom: 20px;
    .active {
      background: #fff;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      color: #303133;
    }
    ul {
      display: flex;
      justify-content: flex-start;
      li {
        // margin-left: 20px;
        // height: 36px;
        // background: rgba(247, 247, 247, 1);
        // border-radius: 4px;
        // font-weight: 600;
        color: #909399;
        padding: 5px 10px;
        box-sizing: border-box;
        line-height: 24px;
        cursor: pointer;
      }
      li:nth-child(1) {
        margin-left: 0;
      }
    }
  }
  .minFooter {
    width: 372px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: auto;
    div {
      cursor: pointer;
    }
    .clear-btn {
      width: 80px;
      height: 36px;
      line-height: 36px;
      background: #f5f7fa;
      border-radius: 18px;
      text-align: center;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      background: #f5f7fa;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .search-btn {
      width: 252px;
      height: 48px;
      line-height: 48px;
      background: #303133;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #ffffff;
      text-align: center;
      background: #303133;
    }
  }
}
</style>
